import { jsx as v } from "react/jsx-runtime";
import { forwardRef as E, useRef as R, useCallback as l } from "react";
import { Input as x } from "../Input/Input.mjs";
const w = E(
  ({ onBlur: a, onChange: n, ...u }, c) => {
    const p = c || R(null), d = l(
      (t) => {
        a == null || a(t);
        const e = t.target.value, r = new RegExp(/^([A-Za-z]\d[A-Za-z])[ -]?(\d[A-Za-z]\d)$/);
        if (r.test(e)) {
          const o = e.match(r), s = p;
          if (s.current && o) {
            const m = `${o[1]} ${o[2]}`.toUpperCase();
            Object.getOwnPropertyDescriptor(
              window.HTMLInputElement.prototype,
              "value"
            ).set.call(s.current, m);
            const f = new InputEvent("input", { bubbles: !0 });
            s.current.dispatchEvent(f);
          }
        }
      },
      [a, p]
    ), i = l(
      (t) => {
        let e = !1;
        new RegExp(/^([A-Z]\d[A-Z]) (\d[A-Z]\d)$/).test(t.target.value) && (e = !0), n == null || n(t, { valid: e });
      },
      [n]
    );
    return /* @__PURE__ */ v(x, { ref: p, maxLength: 7, onBlur: d, onChange: i, ...u });
  }
);
w.displayName = "PostalCodeInput";
export {
  w as PostalCodeInput
};
